import BaseService from '../base';

class Commune extends BaseService {}

export default new Commune('communes', 'Commune');
